import { getUser } from './setting';
import { USER_ROLES } from './constant';

export function canUploadPromptsOrMoh(): boolean {
  const role = getUser()?.role;

  return role === USER_ROLES.CALL_CENTRE_ADMIN || role === USER_ROLES.SUPERADMIN;
}

export function canUploadMoh(): boolean {
  return getUser()?.role === USER_ROLES.CALL_CENTRE_ADMIN;
}

export function canCreateCampaign(): boolean {
  return getUser()?.role === USER_ROLES.CALL_CENTRE_ADMIN;
}

export function canBulkUploadAgents(): boolean {
  return getUser()?.role === USER_ROLES.CALL_CENTRE_ADMIN;
}

export function canImportContactGroupMembers(): boolean {
  return getUser()?.role === USER_ROLES.CALL_CENTRE_ADMIN;
}

export function canDownloadReports(): boolean {
  const role = getUser()?.role;

  return role !== USER_ROLES.CALL_CENTRE_AGENT && role !== USER_ROLES.CALL_CENTRE_TEAM_LEAD;
}
